import React from "react";

type IconProps = {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
};

export const PauseIcon = ({
  width = 16,
  height = 16,
  color = "#012604",
  className,
}: IconProps): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M11.9997 2H9.99967C9.63148 2 9.33301 2.29848 9.33301 2.66667V13.3333C9.33301 13.7015 9.63148 14 9.99967 14H11.9997C12.3679 14 12.6663 13.7015 12.6663 13.3333V2.66667C12.6663 2.29848 12.3679 2 11.9997 2Z"
      fill={color}
    />
    <path
      d="M5.99967 2H3.99967C3.63148 2 3.33301 2.29848 3.33301 2.66667V13.3333C3.33301 13.7015 3.63148 14 3.99967 14H5.99967C6.36786 14 6.66634 13.7015 6.66634 13.3333V2.66667C6.66634 2.29848 6.36786 2 5.99967 2Z"
      fill={color}
    />
  </svg>
);

export const PlayIcon = ({
  width = 11,
  height = 12,
  color = "#012604",
  className,
}: IconProps): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 11 12"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M5.85751e-08 1.33373C-6.9472e-05 1.09912 0.0617635 0.868653 0.179256 0.665589C0.296748 0.462524 0.46574 0.294055 0.669167 0.177193C0.872595 0.06033 1.10326 -0.000788726 1.33786 7.68478e-06C1.57246 0.000804095 1.8027 0.0634876 2.00533 0.181729L10.0033 4.84706C10.2052 4.96418 10.3727 5.13223 10.4893 5.3344C10.6058 5.53657 10.6673 5.76579 10.6675 5.99915C10.6677 6.23251 10.6066 6.46184 10.4904 6.66422C10.3742 6.86659 10.207 7.03493 10.0053 7.1524L2.00533 11.8191C1.8027 11.9373 1.57246 12 1.33786 12.0008C1.10326 12.0016 0.872595 11.9405 0.669167 11.8236C0.46574 11.7067 0.296748 11.5383 0.179256 11.3352C0.0617635 11.1321 -6.9472e-05 10.9017 5.85751e-08 10.6671V1.33373Z"
      fill={color}
    />
  </svg>
);
